import { render, staticRenderFns } from "./latestPoll.vue?vue&type=template&id=60fe9b1d&scoped=true&"
import script from "./latestPoll.vue?vue&type=script&lang=js&"
export * from "./latestPoll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fe9b1d",
  null
  
)

export default component.exports